export default "__VITE_ASSET__DqXYyiSI__"